import React from "react";
import ReactFormat from "react-number-format";

export default function Money({ value }) {
  return (
    <ReactFormat
      displayType="text"
      prefix="$"
      value={Number(value) || 0}
      thousandSeparator={true}
      decimalScale={2}
      fixedDecimalScale={true}
    />
  );
}
